import React from 'react'
import styled from 'styled-components'

const StyledP = styled.p`
  color: #171d20;
  font-size: 14px;
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica,
    Arial, sans-serif;
`

const P = ({ children }) => <StyledP>{children}</StyledP>

export default P
